const T="100ms";export{T as DEFAULT_TRANSITION_MS};
